import { createModel } from "@@/package/utils/ModelUtil";
import Model from "@@/package/mapper/Model";

export class AssessmentAvailableCountModel extends Model {
    constructor(
        public availableCount: number = 0,
        public attemptsCount: number = 0
    ) {
        super();
    }

    public static create(model: Partial<AssessmentAvailableCountModel>): AssessmentAvailableCountModel {
        return createModel<AssessmentAvailableCountModel>(AssessmentAvailableCountModel, {
            ...model
        });
    }
}
